import React from 'react';
import { TablePagination } from '@mui/material';
import { tokens } from '../../theme';

export const ALL_ROWS = -1;
export const DEFAULT_ROWS_PER_PAGE = 25;
const OPTIONS = [10, 25, 50, 100, { label: 'All', value: ALL_ROWS }];

// The one pagination footer used under every table in the portal.
const AppPagination = ({ count, page, rowsPerPage, onPageChange, onRowsPerPageChange }) => (
    <TablePagination
        component="div"
        count={count}
        page={rowsPerPage === ALL_ROWS ? 0 : Math.min(page, Math.max(0, Math.ceil(count / rowsPerPage) - 1))}
        rowsPerPage={rowsPerPage}
        onPageChange={(e, p) => onPageChange(p)}
        onRowsPerPageChange={(e) => onRowsPerPageChange(parseInt(e.target.value, 10))}
        rowsPerPageOptions={OPTIONS}
        sx={{ borderTop: `1px solid ${tokens.line}` }}
    />
);

export const pageSlice = (rows, page, rowsPerPage) =>
    rowsPerPage === ALL_ROWS ? rows : rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

export default AppPagination;
